export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return false

    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const hasFinePointer = (): boolean => {
    if (typeof window === 'undefined') return false

    return window.matchMedia('(hover: hover) and (pointer: fine)').matches
}

export const clamp = (value: number, min: number, max: number): number => Math.min(max, Math.max(min, value))

export const lerp = (from: number, to: number, amount: number): number => from + (to - from) * amount
